$(document).ready(function() {
    initSlider();

    var target = document.querySelector('#ProductGridContainer');
    target.addEventListener('ProductGridReload', function () {
        initSlider();
    });

    function initSlider() {
        var swiperThumbs = new Swiper(".product-slider-swiper-thumbs", {
            spaceBetween: 2,
            slidesPerView: 'auto',
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                991: {
                    direction: 'vertical',
                }
            }
        });

        var slider = new Swiper(".product-slider-swiper-main", {
            slidesPerView: 1.44,
            centeredSlides: true,
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                991: {
                    direction: 'vertical',
                }
            },
            on: {
                slideChange: function () {
                    calculateLeftForTagOnCollectionSliderMode();
                    handleScrollLock(slider, false); // Vérifie la position et verrouille le scroll lors de chaque changement de slide
                    $("html, body").scrollTop($(".product-slider-swiper-main").offset().top);
                },
            },
        });

        slider.controller.control = swiperThumbs;
        swiperThumbs.controller.control = slider;

        // Ajout du scroll pour changer de slide
        addScrollEvent(slider);
    }
});

function addScrollEvent(slider) {
    var scrollTimeout;
    var isSliderVisible = false; // Vérifie si le slider est visible
    var scrollLocked = false; // Si le scroll est verrouillé

    function checkSliderVisibility() {
        var sliderElement = $(".product-slider-swiper-main");
        var rect = sliderElement[0].getBoundingClientRect();
        isSliderVisible = rect.top <= window.innerHeight && rect.bottom >= 0;
    }

    $(window).on("scroll", function() {
        checkSliderVisibility();
        handleScrollLock(slider, isSliderVisible); // Vérifie le verrouillage du scroll à chaque mouvement du scroll
    });

    $(".product-slider-content.product-mode-content").on("wheel", function(event) {
        if (window.innerWidth <= 990) return; // Désactive la fonctionnalité sur petits écrans

        var currentIndex = slider.activeIndex;
        var totalSlides = slider.slides.length - 1;

        var isAtFirstSlide = currentIndex === 0 && event.originalEvent.deltaY < 0;
        var isAtLastSlide = currentIndex === totalSlides && event.originalEvent.deltaY > 0;

        if (!isSliderVisible) {
            lockPageScroll(false);
            return;
        }

        if (isAtFirstSlide || isAtLastSlide) {
            lockPageScroll(false);
            return;
        }

        event.preventDefault();

        if (scrollTimeout) return;

        scrollTimeout = setTimeout(() => {
            scrollTimeout = null;
        }, 300);

        if (event.originalEvent.deltaY > 0) {
            slider.slideNext();
        } else {
            slider.slidePrev();
        }
    });
}

function handleScrollLock(slider, isSliderVisible) {
    if (window.innerWidth <= 990) {
        lockPageScroll(false); // Désactive le verrouillage si l'écran est trop petit
        return;
    }

    if (!isSliderVisible) {
        lockPageScroll(false);
        return;
    }

    var currentIndex = slider.activeIndex;
    var totalSlides = slider.slides.length - 1;

    var isAtFirstSlide = currentIndex === 0;
    var isAtLastSlide = currentIndex === totalSlides;

    if (isAtFirstSlide || isAtLastSlide) {
        lockPageScroll(false);
    } else {
        lockPageScroll(true);
    }
}

function lockPageScroll(lock) {
    if (window.innerWidth <= 990) {
        $("body").css("overflow", "auto"); // Toujours activer le scroll sur petits écrans
        return;
    }

    $("body").css("overflow", lock ? "hidden" : "auto");
}

$(window).resize(function() {
    calculateLeftForTagOnCollectionSliderMode();
    handleScrollLock(null, false); // Met à jour le comportement de verrouillage lors du redimensionnement
});

function calculateLeftForTagOnCollectionSliderMode() {
    var screenWidth = $(window).width();
    if($('.product-slider-swiper-main .swiper-slide-active .product-card-content')){
        var productTagParentWidth = $('.product-slider-swiper-main .swiper-slide-active .product-card-content').first().width();
        var leftSpacesWidth = (screenWidth - productTagParentWidth) / 2;
        $('.product-slider-swiper-main .product-tag').css('left', -leftSpacesWidth + 12);
    }
}
